var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _vm.displaySection(_vm.order)
      ? _c("div", { staticClass: "card panel-white" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("label", [
              _vm._v(
                _vm._s(
                  _vm.$t("message.my_reservations.request_additional_hours")
                )
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-3" }, [
              _vm._m(0),
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      "message.my_reservations.provider_request_additional_hours"
                    )
                  ) +
                  "\n      "
              )
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "bullet-notification" }, [
      _c("i", { staticClass: "fas fa-circle" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70e233f8", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70e233f8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/components/ConfirmRequestAdditionalHoursSection.vue
// module id = 1724
// module chunks = 0